import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2, Plus, CalendarCheck, ExternalLink } from "lucide-react";
import { PageBody, PageHeader } from "@/components/Page";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { NewWorkspaceDialog } from "@/components/NewWorkspaceDialog";
import api from "@/lib/api";

export default function Workspaces() {
  const navigate = useNavigate();
  const [ws, setWs] = useState([]);
  const [open, setOpen] = useState(false);

  const load = async () => { const { data } = await api.get("/workspaces"); setWs(data); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);

  const openWs = async (id) => { await api.post(`/workspaces/${id}/activate`); navigate("/app/settings/integrations"); };

  return (
    <PageBody>
      <PageHeader eyebrow="Admin" title="Workspaces" subtitle="Each workspace has its own booking URL. Calendly tokens are never shared across workspaces."
        actions={<Button className="rounded-md bg-amber-500 text-black hover:bg-amber-400" onClick={() => setOpen(true)} data-testid="new-workspace-btn"><Plus className="h-4 w-4 mr-1.5" /> New workspace</Button>} />

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="workspaces-list">
        {ws.map((w) => (
          <div key={w.id} className="rounded-xl border border-border/70 bg-card/50 p-5" data-testid={`workspace-${w.id}`}>
            <div className="flex items-center gap-2 mb-3">
              <Building2 className="h-4 w-4 text-amber-500" />
              <span className="font-medium">{w.name}</span>
              {w.sector === "public" && <Badge variant="outline" className="text-[10px] text-sky-500">gov</Badge>}
            </div>
            <div className="text-xs text-muted-foreground flex items-center gap-1.5">
              <CalendarCheck className="h-3.5 w-3.5" />
              {w.booking_url
                ? <a href={w.booking_url} target="_blank" rel="noreferrer" className="text-sky-500 hover:underline inline-flex items-center gap-1 truncate" data-testid={`ws-booking-${w.id}`}>{w.booking_url}<ExternalLink className="h-3 w-3 shrink-0" /></a>
                : <span className="text-rose-500">No booking URL set</span>}
            </div>
            <Button size="sm" variant="outline" className="rounded-md mt-4 w-full" onClick={() => openWs(w.id)} data-testid={`manage-booking-${w.id}`}>Manage booking</Button>
          </div>
        ))}
      </div>

      <NewWorkspaceDialog open={open} onOpenChange={setOpen} activate={false} onCreated={load} />
    </PageBody>
  );
}
